var bt = Object.defineProperty;
var wt = (e, t, r) => t in e ? bt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var me = (e, t, r) => (wt(e, typeof t != "symbol" ? t + "" : t, r), r);
var Ce = function() {
  return Ce = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, Ce.apply(this, arguments);
};
function G(e, t, r, n) {
  function o(a) {
    return a instanceof r ? a : new r(function(s) {
      s(a);
    });
  }
  return new (r || (r = Promise))(function(a, s) {
    function c(l) {
      try {
        i(n.next(l));
      } catch (u) {
        s(u);
      }
    }
    function f(l) {
      try {
        i(n.throw(l));
      } catch (u) {
        s(u);
      }
    }
    function i(l) {
      l.done ? a(l.value) : o(l.value).then(c, f);
    }
    i((n = n.apply(e, t || [])).next());
  });
}
function B(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, o, a, s;
  return s = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function c(i) {
    return function(l) {
      return f([i, l]);
    };
  }
  function f(i) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, i[0] && (r = 0)), r; )
      try {
        if (n = 1, o && (a = i[0] & 2 ? o.return : i[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, i[1])).done)
          return a;
        switch (o = 0, a && (i = [i[0] & 2, a.value]), i[0]) {
          case 0:
          case 1:
            a = i;
            break;
          case 4:
            return r.label++, { value: i[1], done: !1 };
          case 5:
            r.label++, o = i[1], i = [0];
            continue;
          case 7:
            i = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (i[0] === 6 || i[0] === 2)) {
              r = 0;
              continue;
            }
            if (i[0] === 3 && (!a || i[1] > a[0] && i[1] < a[3])) {
              r.label = i[1];
              break;
            }
            if (i[0] === 6 && r.label < a[1]) {
              r.label = a[1], a = i;
              break;
            }
            if (a && r.label < a[2]) {
              r.label = a[2], r.ops.push(i);
              break;
            }
            a[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        i = t.call(e, r);
      } catch (l) {
        i = [6, l], o = 0;
      } finally {
        n = a = 0;
      }
    if (i[0] & 5)
      throw i[1];
    return { value: i[0] ? i[1] : void 0, done: !0 };
  }
}
function Qe(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, o = t.length, a; n < o; n++)
      (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var qe = "4.0.1";
function ee(e, t) {
  return new Promise(function(r) {
    return setTimeout(r, e, t);
  });
}
function we() {
  return ee(0);
}
function St(e, t) {
  t === void 0 && (t = 1 / 0);
  var r = window.requestIdleCallback;
  return r ? new Promise(function(n) {
    return r.call(window, function() {
      return n();
    }, { timeout: t });
  }) : ee(Math.min(e, t));
}
function Ke(e) {
  return !!e && typeof e.then == "function";
}
function Te(e, t) {
  try {
    var r = e();
    Ke(r) ? r.then(function(n) {
      return t(!0, n);
    }, function(n) {
      return t(!1, n);
    }) : t(!0, r);
  } catch (n) {
    t(!1, n);
  }
}
function Ze(e, t, r) {
  return r === void 0 && (r = 16), G(this, void 0, void 0, function() {
    var n, o, a, s;
    return B(this, function(c) {
      switch (c.label) {
        case 0:
          n = Array(e.length), o = Date.now(), a = 0, c.label = 1;
        case 1:
          return a < e.length ? (n[a] = t(e[a], a), s = Date.now(), s >= o + r ? (o = s, [4, ee(0)]) : [3, 3]) : [3, 4];
        case 2:
          c.sent(), c.label = 3;
        case 3:
          return ++a, [3, 1];
        case 4:
          return [2, n];
      }
    });
  });
}
function ne(e) {
  e.then(void 0, function() {
  });
}
function xt(e, t) {
  for (var r = 0, n = e.length; r < n; ++r)
    if (e[r] === t)
      return !0;
  return !1;
}
function kt(e, t) {
  return !xt(e, t);
}
function Pe(e) {
  return parseInt(e);
}
function j(e) {
  return parseFloat(e);
}
function D(e, t) {
  return typeof e == "number" && isNaN(e) ? t : e;
}
function _(e) {
  return e.reduce(function(t, r) {
    return t + (r ? 1 : 0);
  }, 0);
}
function $e(e, t) {
  if (t === void 0 && (t = 1), Math.abs(t) >= 1)
    return Math.round(e / t) * t;
  var r = 1 / t;
  return Math.round(e * r) / r;
}
function Lt(e) {
  for (var t, r, n = "Unexpected syntax '".concat(e, "'"), o = /^\s*([a-z-]*)(.*)$/i.exec(e), a = o[1] || void 0, s = {}, c = /([.:#][\w-]+|\[.+?\])/gi, f = function(y, x) {
    s[y] = s[y] || [], s[y].push(x);
  }; ; ) {
    var i = c.exec(o[2]);
    if (!i)
      break;
    var l = i[0];
    switch (l[0]) {
      case ".":
        f("class", l.slice(1));
        break;
      case "#":
        f("id", l.slice(1));
        break;
      case "[": {
        var u = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(l);
        if (u)
          f(u[1], (r = (t = u[4]) !== null && t !== void 0 ? t : u[5]) !== null && r !== void 0 ? r : "");
        else
          throw new Error(n);
        break;
      }
      default:
        throw new Error(n);
    }
  }
  return [a, s];
}
function Ct(e) {
  for (var t = new Uint8Array(e.length), r = 0; r < e.length; r++) {
    var n = e.charCodeAt(r);
    if (n < 0 || n > 127)
      return new TextEncoder().encode(e);
    t[r] = n;
  }
  return t;
}
function X(e, t) {
  var r = e[0] >>> 16, n = e[0] & 65535, o = e[1] >>> 16, a = e[1] & 65535, s = t[0] >>> 16, c = t[0] & 65535, f = t[1] >>> 16, i = t[1] & 65535, l = 0, u = 0, y = 0, x = 0;
  x += a + i, y += x >>> 16, x &= 65535, y += o + f, u += y >>> 16, y &= 65535, u += n + c, l += u >>> 16, u &= 65535, l += r + s, l &= 65535, e[0] = l << 16 | u, e[1] = y << 16 | x;
}
function T(e, t) {
  var r = e[0] >>> 16, n = e[0] & 65535, o = e[1] >>> 16, a = e[1] & 65535, s = t[0] >>> 16, c = t[0] & 65535, f = t[1] >>> 16, i = t[1] & 65535, l = 0, u = 0, y = 0, x = 0;
  x += a * i, y += x >>> 16, x &= 65535, y += o * i, u += y >>> 16, y &= 65535, y += a * f, u += y >>> 16, y &= 65535, u += n * i, l += u >>> 16, u &= 65535, u += o * f, l += u >>> 16, u &= 65535, u += a * c, l += u >>> 16, u &= 65535, l += r * i + n * f + o * c + a * s, l &= 65535, e[0] = l << 16 | u, e[1] = y << 16 | x;
}
function Q(e, t) {
  var r = e[0];
  t %= 64, t === 32 ? (e[0] = e[1], e[1] = r) : t < 32 ? (e[0] = r << t | e[1] >>> 32 - t, e[1] = e[1] << t | r >>> 32 - t) : (t -= 32, e[0] = e[1] << t | r >>> 32 - t, e[1] = r << t | e[1] >>> 32 - t);
}
function A(e, t) {
  t %= 64, t !== 0 && (t < 32 ? (e[0] = e[1] >>> 32 - t, e[1] = e[1] << t) : (e[0] = e[1] << t - 32, e[1] = 0));
}
function P(e, t) {
  e[0] ^= t[0], e[1] ^= t[1];
}
var Vt = [4283543511, 3981806797], Ft = [3301882366, 444984403];
function je(e) {
  var t = [0, e[0] >>> 1];
  P(e, t), T(e, Vt), t[1] = e[0] >>> 1, P(e, t), T(e, Ft), t[1] = e[0] >>> 1, P(e, t);
}
var he = [2277735313, 289559509], pe = [1291169091, 658871167], Ge = [0, 5], Rt = [0, 1390208809], Wt = [0, 944331445];
function Pt(e, t) {
  var r = Ct(e);
  t = t || 0;
  var n = [0, r.length], o = n[1] % 16, a = n[1] - o, s = [0, t], c = [0, t], f = [0, 0], i = [0, 0], l;
  for (l = 0; l < a; l = l + 16)
    f[0] = r[l + 4] | r[l + 5] << 8 | r[l + 6] << 16 | r[l + 7] << 24, f[1] = r[l] | r[l + 1] << 8 | r[l + 2] << 16 | r[l + 3] << 24, i[0] = r[l + 12] | r[l + 13] << 8 | r[l + 14] << 16 | r[l + 15] << 24, i[1] = r[l + 8] | r[l + 9] << 8 | r[l + 10] << 16 | r[l + 11] << 24, T(f, he), Q(f, 31), T(f, pe), P(s, f), Q(s, 27), X(s, c), T(s, Ge), X(s, Rt), T(i, pe), Q(i, 33), T(i, he), P(c, i), Q(c, 31), X(c, s), T(c, Ge), X(c, Wt);
  f[0] = 0, f[1] = 0, i[0] = 0, i[1] = 0;
  var u = [0, 0];
  switch (o) {
    case 15:
      u[1] = r[l + 14], A(u, 48), P(i, u);
    case 14:
      u[1] = r[l + 13], A(u, 40), P(i, u);
    case 13:
      u[1] = r[l + 12], A(u, 32), P(i, u);
    case 12:
      u[1] = r[l + 11], A(u, 24), P(i, u);
    case 11:
      u[1] = r[l + 10], A(u, 16), P(i, u);
    case 10:
      u[1] = r[l + 9], A(u, 8), P(i, u);
    case 9:
      u[1] = r[l + 8], P(i, u), T(i, pe), Q(i, 33), T(i, he), P(c, i);
    case 8:
      u[1] = r[l + 7], A(u, 56), P(f, u);
    case 7:
      u[1] = r[l + 6], A(u, 48), P(f, u);
    case 6:
      u[1] = r[l + 5], A(u, 40), P(f, u);
    case 5:
      u[1] = r[l + 4], A(u, 32), P(f, u);
    case 4:
      u[1] = r[l + 3], A(u, 24), P(f, u);
    case 3:
      u[1] = r[l + 2], A(u, 16), P(f, u);
    case 2:
      u[1] = r[l + 1], A(u, 8), P(f, u);
    case 1:
      u[1] = r[l], P(f, u), T(f, he), Q(f, 31), T(f, pe), P(s, f);
  }
  return P(s, n), P(c, n), X(s, c), X(c, s), je(s), je(c), X(s, c), X(c, s), ("00000000" + (s[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (s[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (c[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (c[1] >>> 0).toString(16)).slice(-8);
}
function Et(e) {
  var t;
  return Ce({ name: e.name, message: e.message, stack: (t = e.stack) === null || t === void 0 ? void 0 : t.split(`
`) }, e);
}
function It(e) {
  return typeof e != "function";
}
function Mt(e, t) {
  var r = new Promise(function(n) {
    var o = Date.now();
    Te(e.bind(null, t), function() {
      for (var a = [], s = 0; s < arguments.length; s++)
        a[s] = arguments[s];
      var c = Date.now() - o;
      if (!a[0])
        return n(function() {
          return { error: a[1], duration: c };
        });
      var f = a[1];
      if (It(f))
        return n(function() {
          return { value: f, duration: c };
        });
      n(function() {
        return new Promise(function(i) {
          var l = Date.now();
          Te(f, function() {
            for (var u = [], y = 0; y < arguments.length; y++)
              u[y] = arguments[y];
            var x = c + Date.now() - l;
            if (!u[0])
              return i({ error: u[1], duration: x });
            i({ value: u[1], duration: x });
          });
        });
      });
    });
  });
  return ne(r), function() {
    return r.then(function(o) {
      return o();
    });
  };
}
function At(e, t, r) {
  var n = Object.keys(e).filter(function(a) {
    return kt(r, a);
  }), o = Ze(n, function(a) {
    return Mt(e[a], t);
  });
  return ne(o), function() {
    return G(this, void 0, void 0, function() {
      var s, c, f, i, l;
      return B(this, function(u) {
        switch (u.label) {
          case 0:
            return [4, o];
          case 1:
            return s = u.sent(), [4, Ze(s, function(y) {
              var x = y();
              return ne(x), x;
            })];
          case 2:
            return c = u.sent(), [
              4,
              Promise.all(c)
              // Keeping the component keys order the same as the source keys order
            ];
          case 3:
            for (f = u.sent(), i = {}, l = 0; l < n.length; ++l)
              i[n[l]] = f[l];
            return [2, i];
        }
      });
    });
  };
}
function et() {
  var e = window, t = navigator;
  return _([
    "MSCSSMatrix" in e,
    "msSetImmediate" in e,
    "msIndexedDB" in e,
    "msMaxTouchPoints" in t,
    "msPointerEnabled" in t
  ]) >= 4;
}
function Tt() {
  var e = window, t = navigator;
  return _(["msWriteProfilerMark" in e, "MSStream" in e, "msLaunchUri" in t, "msSaveBlob" in t]) >= 3 && !et();
}
function Ee() {
  var e = window, t = navigator;
  return _([
    "webkitPersistentStorage" in t,
    "webkitTemporaryStorage" in t,
    t.vendor.indexOf("Google") === 0,
    "webkitResolveLocalFileSystemURL" in e,
    "BatteryManager" in e,
    "webkitMediaStream" in e,
    "webkitSpeechGrammar" in e
  ]) >= 5;
}
function ie() {
  var e = window, t = navigator;
  return _([
    "ApplePayError" in e,
    "CSSPrimitiveValue" in e,
    "Counter" in e,
    t.vendor.indexOf("Apple") === 0,
    "getStorageUpdates" in t,
    "WebKitMediaKeys" in e
  ]) >= 4;
}
function Ie() {
  var e = window;
  return _([
    "safari" in e,
    !("ongestureend" in e),
    !("TouchEvent" in e),
    !("orientation" in e),
    "HTMLElement" in e && !("autocapitalize" in HTMLElement.prototype),
    "Document" in e && "pointerLockElement" in Document.prototype
  ]) >= 4;
}
function tt() {
  var e, t, r = window;
  return _([
    "buildID" in navigator,
    "MozAppearance" in ((t = (e = document.documentElement) === null || e === void 0 ? void 0 : e.style) !== null && t !== void 0 ? t : {}),
    "onmozfullscreenchange" in r,
    "mozInnerScreenX" in r,
    "CSSMozDocumentRule" in r,
    "CanvasCaptureMediaStream" in r
  ]) >= 4;
}
function Zt() {
  var e = window;
  return _([
    !("MediaSettingsRange" in e),
    "RTCEncodedAudioFrame" in e,
    "" + e.Intl == "[object Intl]",
    "" + e.Reflect == "[object Reflect]"
  ]) >= 3;
}
function jt() {
  var e = window;
  return _([
    "DOMRectList" in e,
    "RTCPeerConnectionIceEvent" in e,
    "SVGGeometryElement" in e,
    "ontransitioncancel" in e
  ]) >= 3;
}
function Gt() {
  if (navigator.platform === "iPad")
    return !0;
  var e = screen, t = e.width / e.height;
  return _([
    "MediaSource" in window,
    !!Element.prototype.webkitRequestFullscreen,
    // iPhone 4S that runs iOS 9 matches this. But it won't match the criteria above, so it won't be detected as iPad.
    t > 0.65 && t < 1.53
  ]) >= 2;
}
function Bt() {
  var e = document;
  return e.fullscreenElement || e.msFullscreenElement || e.mozFullScreenElement || e.webkitFullscreenElement || null;
}
function _t() {
  var e = document;
  return (e.exitFullscreen || e.msExitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen).call(e);
}
function rt() {
  var e = Ee(), t = tt();
  if (!e && !t)
    return !1;
  var r = window;
  return _([
    "onorientationchange" in r,
    "orientation" in r,
    e && !("SharedWorker" in r),
    t && /android/i.test(navigator.appVersion)
  ]) >= 2;
}
function Ht() {
  var e = window, t = e.OfflineAudioContext || e.webkitOfflineAudioContext;
  if (!t)
    return -2;
  if (Ot())
    return -1;
  var r = 4500, n = 5e3, o = new t(1, n, 44100), a = o.createOscillator();
  a.type = "triangle", a.frequency.value = 1e4;
  var s = o.createDynamicsCompressor();
  s.threshold.value = -50, s.knee.value = 40, s.ratio.value = 12, s.attack.value = 0, s.release.value = 0.25, a.connect(s), s.connect(o.destination), a.start(0);
  var c = Dt(o), f = c[0], i = c[1], l = f.then(function(u) {
    return Yt(u.getChannelData(0).subarray(r));
  }, function(u) {
    if (u.name === "timeout" || u.name === "suspended")
      return -3;
    throw u;
  });
  return ne(l), function() {
    return i(), l;
  };
}
function Ot() {
  return ie() && !Ie() && !jt();
}
function Dt(e) {
  var t = 3, r = 500, n = 500, o = 5e3, a = function() {
  }, s = new Promise(function(c, f) {
    var i = !1, l = 0, u = 0;
    e.oncomplete = function(F) {
      return c(F.renderedBuffer);
    };
    var y = function() {
      setTimeout(function() {
        return f(Be(
          "timeout"
          /* InnerErrorName.Timeout */
        ));
      }, Math.min(n, u + o - Date.now()));
    }, x = function() {
      try {
        var F = e.startRendering();
        switch (Ke(F) && ne(F), e.state) {
          case "running":
            u = Date.now(), i && y();
            break;
          case "suspended":
            document.hidden || l++, i && l >= t ? f(Be(
              "suspended"
              /* InnerErrorName.Suspended */
            )) : setTimeout(x, r);
            break;
        }
      } catch (w) {
        f(w);
      }
    };
    x(), a = function() {
      i || (i = !0, u > 0 && y());
    };
  });
  return [s, a];
}
function Yt(e) {
  for (var t = 0, r = 0; r < e.length; ++r)
    t += Math.abs(e[r]);
  return t;
}
function Be(e) {
  var t = new Error(e);
  return t.name = e, t;
}
function nt(e, t, r) {
  var n, o, a;
  return r === void 0 && (r = 50), G(this, void 0, void 0, function() {
    var s, c;
    return B(this, function(f) {
      switch (f.label) {
        case 0:
          s = document, f.label = 1;
        case 1:
          return s.body ? [3, 3] : [4, ee(r)];
        case 2:
          return f.sent(), [3, 1];
        case 3:
          c = s.createElement("iframe"), f.label = 4;
        case 4:
          return f.trys.push([4, , 10, 11]), [4, new Promise(function(i, l) {
            var u = !1, y = function() {
              u = !0, i();
            }, x = function(S) {
              u = !0, l(S);
            };
            c.onload = y, c.onerror = x;
            var F = c.style;
            F.setProperty("display", "block", "important"), F.position = "absolute", F.top = "0", F.left = "0", F.visibility = "hidden", t && "srcdoc" in c ? c.srcdoc = t : c.src = "about:blank", s.body.appendChild(c);
            var w = function() {
              var S, C;
              u || (((C = (S = c.contentWindow) === null || S === void 0 ? void 0 : S.document) === null || C === void 0 ? void 0 : C.readyState) === "complete" ? y() : setTimeout(w, 10));
            };
            w();
          })];
        case 5:
          f.sent(), f.label = 6;
        case 6:
          return !((o = (n = c.contentWindow) === null || n === void 0 ? void 0 : n.document) === null || o === void 0) && o.body ? [3, 8] : [4, ee(r)];
        case 7:
          return f.sent(), [3, 6];
        case 8:
          return [4, e(c, c.contentWindow)];
        case 9:
          return [2, f.sent()];
        case 10:
          return (a = c.parentNode) === null || a === void 0 || a.removeChild(c), [
            7
            /*endfinally*/
          ];
        case 11:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function Nt(e) {
  for (var t = Lt(e), r = t[0], n = t[1], o = document.createElement(r ?? "div"), a = 0, s = Object.keys(n); a < s.length; a++) {
    var c = s[a], f = n[c].join(" ");
    c === "style" ? Xt(o.style, f) : o.setAttribute(c, f);
  }
  return o;
}
function Xt(e, t) {
  for (var r = 0, n = t.split(";"); r < n.length; r++) {
    var o = n[r], a = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(o);
    if (a) {
      var s = a[1], c = a[2], f = a[4];
      e.setProperty(s, c, f || "");
    }
  }
}
var zt = "mmMwWLliI0O&1", Jt = "48px", q = ["monospace", "sans-serif", "serif"], _e = [
  // This is android-specific font from "Roboto" family
  "sans-serif-thin",
  "ARNO PRO",
  "Agency FB",
  "Arabic Typesetting",
  "Arial Unicode MS",
  "AvantGarde Bk BT",
  "BankGothic Md BT",
  "Batang",
  "Bitstream Vera Sans Mono",
  "Calibri",
  "Century",
  "Century Gothic",
  "Clarendon",
  "EUROSTILE",
  "Franklin Gothic",
  "Futura Bk BT",
  "Futura Md BT",
  "GOTHAM",
  "Gill Sans",
  "HELV",
  "Haettenschweiler",
  "Helvetica Neue",
  "Humanst521 BT",
  "Leelawadee",
  "Letter Gothic",
  "Levenim MT",
  "Lucida Bright",
  "Lucida Sans",
  "Menlo",
  "MS Mincho",
  "MS Outlook",
  "MS Reference Specialty",
  "MS UI Gothic",
  "MT Extra",
  "MYRIAD PRO",
  "Marlett",
  "Meiryo UI",
  "Microsoft Uighur",
  "Minion Pro",
  "Monotype Corsiva",
  "PMingLiU",
  "Pristina",
  "SCRIPTINA",
  "Segoe UI Light",
  "Serifa",
  "SimHei",
  "Small Fonts",
  "Staccato222 BT",
  "TRAJAN PRO",
  "Univers CE 55 Medium",
  "Vrinda",
  "ZWAdobeF"
];
function Ut() {
  var e = this;
  return nt(function(t, r) {
    var n = r.document;
    return G(e, void 0, void 0, function() {
      var o, a, s, c, f, i, l, u, y, x, F, w;
      return B(this, function(S) {
        switch (S.label) {
          case 0:
            return o = n.body, o.style.fontSize = Jt, a = n.createElement("div"), a.style.setProperty("visibility", "hidden", "important"), s = {}, c = {}, f = function(C) {
              var d = n.createElement("span"), v = d.style;
              return v.position = "absolute", v.top = "0", v.left = "0", v.fontFamily = C, d.textContent = zt, a.appendChild(d), d;
            }, i = function(C, d) {
              return f("'".concat(C, "',").concat(d));
            }, l = function() {
              return q.map(f);
            }, u = function() {
              for (var C = {}, d = function(L) {
                C[L] = q.map(function(R) {
                  return i(L, R);
                });
              }, v = 0, b = _e; v < b.length; v++) {
                var k = b[v];
                d(k);
              }
              return C;
            }, y = function(C) {
              return q.some(function(d, v) {
                return C[v].offsetWidth !== s[d] || C[v].offsetHeight !== c[d];
              });
            }, x = l(), F = u(), o.appendChild(a), [
              4,
              we()
              // get the default width for the three base fonts
            ];
          case 1:
            for (S.sent(), w = 0; w < q.length; w++)
              s[q[w]] = x[w].offsetWidth, c[q[w]] = x[w].offsetHeight;
            return [2, _e.filter(function(C) {
              return y(F[C]);
            })];
        }
      });
    });
  });
}
function Qt() {
  var e = navigator.plugins;
  if (e) {
    for (var t = [], r = 0; r < e.length; ++r) {
      var n = e[r];
      if (n) {
        for (var o = [], a = 0; a < n.length; ++a) {
          var s = n[a];
          o.push({
            type: s.type,
            suffixes: s.suffixes
          });
        }
        t.push({
          name: n.name,
          description: n.description,
          mimeTypes: o
        });
      }
    }
    return t;
  }
}
function qt() {
  return G(this, void 0, void 0, function() {
    var e, t, r, n, o, a, s, c;
    return B(this, function(f) {
      switch (f.label) {
        case 0:
          return e = !1, n = Kt(), o = n[0], a = n[1], $t(o, a) ? [3, 1] : (t = r = "unsupported", [3, 5]);
        case 1:
          return e = er(a), tr(o, a), [4, we()];
        case 2:
          return f.sent(), s = Se(o), c = Se(o), s === c ? [3, 3] : (t = r = "unstable", [3, 5]);
        case 3:
          return r = s, rr(o, a), [4, we()];
        case 4:
          f.sent(), t = Se(o), f.label = 5;
        case 5:
          return [2, { winding: e, geometry: t, text: r }];
      }
    });
  });
}
function Kt() {
  var e = document.createElement("canvas");
  return e.width = 1, e.height = 1, [e, e.getContext("2d")];
}
function $t(e, t) {
  return !!(t && e.toDataURL);
}
function er(e) {
  return e.rect(0, 0, 10, 10), e.rect(2, 2, 6, 6), !e.isPointInPath(5, 5, "evenodd");
}
function tr(e, t) {
  e.width = 240, e.height = 60, t.textBaseline = "alphabetic", t.fillStyle = "#f60", t.fillRect(100, 1, 62, 20), t.fillStyle = "#069", t.font = '11pt "Times New Roman"';
  var r = "Cwm fjordbank gly ".concat(
    String.fromCharCode(55357, 56835)
    /* 😃 */
  );
  t.fillText(r, 2, 15), t.fillStyle = "rgba(102, 204, 0, 0.2)", t.font = "18pt Arial", t.fillText(r, 4, 45);
}
function rr(e, t) {
  e.width = 122, e.height = 110, t.globalCompositeOperation = "multiply";
  for (var r = 0, n = [
    ["#f2f", 40, 40],
    ["#2ff", 80, 40],
    ["#ff2", 60, 80]
  ]; r < n.length; r++) {
    var o = n[r], a = o[0], s = o[1], c = o[2];
    t.fillStyle = a, t.beginPath(), t.arc(s, c, 40, 0, Math.PI * 2, !0), t.closePath(), t.fill();
  }
  t.fillStyle = "#f9c", t.arc(60, 60, 60, 0, Math.PI * 2, !0), t.arc(60, 60, 20, 0, Math.PI * 2, !0), t.fill("evenodd");
}
function Se(e) {
  return e.toDataURL();
}
function nr() {
  var e = navigator, t = 0, r;
  e.maxTouchPoints !== void 0 ? t = Pe(e.maxTouchPoints) : e.msMaxTouchPoints !== void 0 && (t = e.msMaxTouchPoints);
  try {
    document.createEvent("TouchEvent"), r = !0;
  } catch {
    r = !1;
  }
  var n = "ontouchstart" in window;
  return {
    maxTouchPoints: t,
    touchEvent: r,
    touchStart: n
  };
}
function ar() {
  return navigator.oscpu;
}
function ir() {
  var e = navigator, t = [], r = e.language || e.userLanguage || e.browserLanguage || e.systemLanguage;
  if (r !== void 0 && t.push([r]), Array.isArray(e.languages))
    Ee() && Zt() || t.push(e.languages);
  else if (typeof e.languages == "string") {
    var n = e.languages;
    n && t.push(n.split(","));
  }
  return t;
}
function or() {
  return window.screen.colorDepth;
}
function sr() {
  return D(j(navigator.deviceMemory), void 0);
}
function cr() {
  var e = screen, t = function(n) {
    return D(Pe(n), null);
  }, r = [t(e.width), t(e.height)];
  return r.sort().reverse(), r;
}
var ur = 2500, fr = 10, ye, xe;
function lr() {
  if (xe === void 0) {
    var e = function() {
      var t = Ve();
      Fe(t) ? xe = setTimeout(e, ur) : (ye = t, xe = void 0);
    };
    e();
  }
}
function dr() {
  var e = this;
  return lr(), function() {
    return G(e, void 0, void 0, function() {
      var t;
      return B(this, function(r) {
        switch (r.label) {
          case 0:
            return t = Ve(), Fe(t) ? ye ? [2, Qe([], ye, !0)] : Bt() ? [4, _t()] : [3, 2] : [3, 2];
          case 1:
            r.sent(), t = Ve(), r.label = 2;
          case 2:
            return Fe(t) || (ye = t), [2, t];
        }
      });
    });
  };
}
function vr() {
  var e = this, t = dr();
  return function() {
    return G(e, void 0, void 0, function() {
      var r, n;
      return B(this, function(o) {
        switch (o.label) {
          case 0:
            return [4, t()];
          case 1:
            return r = o.sent(), n = function(a) {
              return a === null ? null : $e(a, fr);
            }, [2, [n(r[0]), n(r[1]), n(r[2]), n(r[3])]];
        }
      });
    });
  };
}
function Ve() {
  var e = screen;
  return [
    D(j(e.availTop), null),
    D(j(e.width) - j(e.availWidth) - D(j(e.availLeft), 0), null),
    D(j(e.height) - j(e.availHeight) - D(j(e.availTop), 0), null),
    D(j(e.availLeft), null)
  ];
}
function Fe(e) {
  for (var t = 0; t < 4; ++t)
    if (e[t])
      return !1;
  return !0;
}
function mr() {
  return D(Pe(navigator.hardwareConcurrency), void 0);
}
function hr() {
  var e, t = (e = window.Intl) === null || e === void 0 ? void 0 : e.DateTimeFormat;
  if (t) {
    var r = new t().resolvedOptions().timeZone;
    if (r)
      return r;
  }
  var n = -pr();
  return "UTC".concat(n >= 0 ? "+" : "").concat(Math.abs(n));
}
function pr() {
  var e = (/* @__PURE__ */ new Date()).getFullYear();
  return Math.max(
    // `getTimezoneOffset` returns a number as a string in some unidentified cases
    j(new Date(e, 0, 1).getTimezoneOffset()),
    j(new Date(e, 6, 1).getTimezoneOffset())
  );
}
function gr() {
  try {
    return !!window.sessionStorage;
  } catch {
    return !0;
  }
}
function yr() {
  try {
    return !!window.localStorage;
  } catch {
    return !0;
  }
}
function br() {
  if (!(et() || Tt()))
    try {
      return !!window.indexedDB;
    } catch {
      return !0;
    }
}
function wr() {
  return !!window.openDatabase;
}
function Sr() {
  return navigator.cpuClass;
}
function xr() {
  var e = navigator.platform;
  return e === "MacIntel" && ie() && !Ie() ? Gt() ? "iPad" : "iPhone" : e;
}
function kr() {
  return navigator.vendor || "";
}
function Lr() {
  for (var e = [], t = 0, r = [
    // Blink and some browsers on iOS
    "chrome",
    // Safari on macOS
    "safari",
    // Chrome on iOS (checked in 85 on 13 and 87 on 14)
    "__crWeb",
    "__gCrWeb",
    // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
    "yandex",
    // Yandex Browser on iOS (checked in 21.2 on 14)
    "__yb",
    "__ybro",
    // Firefox on iOS (checked in 32 on 14)
    "__firefox__",
    // Edge on iOS (checked in 46 on 14)
    "__edgeTrackingPreventionStatistics",
    "webkit",
    // Opera Touch on iOS (checked in 2.6 on 14)
    "oprt",
    // Samsung Internet on Android (checked in 11.1)
    "samsungAr",
    // UC Browser on Android (checked in 12.10 and 13.0)
    "ucweb",
    "UCShellJava",
    // Puffin on Android (checked in 9.0)
    "puffinDevice"
    // UC on iOS and Opera on Android have no specific global variables
    // Edge for Android isn't checked
  ]; t < r.length; t++) {
    var n = r[t], o = window[n];
    o && typeof o == "object" && e.push(n);
  }
  return e.sort();
}
function Cr() {
  var e = document;
  try {
    e.cookie = "cookietest=1; SameSite=Strict;";
    var t = e.cookie.indexOf("cookietest=") !== -1;
    return e.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", t;
  } catch {
    return !1;
  }
}
function Vr() {
  var e = atob;
  return {
    abpIndo: [
      "#Iklan-Melayang",
      "#Kolom-Iklan-728",
      "#SidebarIklan-wrapper",
      '[title="ALIENBOLA" i]',
      e("I0JveC1CYW5uZXItYWRz")
    ],
    abpvn: [".quangcao", "#mobileCatfish", e("LmNsb3NlLWFkcw=="), '[id^="bn_bottom_fixed_"]', "#pmadv"],
    adBlockFinland: [
      ".mainostila",
      e("LnNwb25zb3JpdA=="),
      ".ylamainos",
      e("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd")
    ],
    adBlockPersian: [
      "#navbar_notice_50",
      ".kadr",
      'TABLE[width="140px"]',
      "#divAgahi",
      e("YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd")
    ],
    adBlockWarningRemoval: [
      "#adblock-honeypot",
      ".adblocker-root",
      ".wp_adblock_detect",
      e("LmhlYWRlci1ibG9ja2VkLWFk"),
      e("I2FkX2Jsb2NrZXI=")
    ],
    adGuardAnnoyances: [
      ".hs-sosyal",
      "#cookieconsentdiv",
      'div[class^="app_gdpr"]',
      ".as-oil",
      '[data-cypress="soft-push-notification-modal"]'
    ],
    adGuardBase: [
      ".BetterJsPopOverlay",
      e("I2FkXzMwMFgyNTA="),
      e("I2Jhbm5lcmZsb2F0MjI="),
      e("I2NhbXBhaWduLWJhbm5lcg=="),
      e("I0FkLUNvbnRlbnQ=")
    ],
    adGuardChinese: [
      e("LlppX2FkX2FfSA=="),
      e("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"),
      "#widget-quan",
      e("YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd"),
      e("YVtocmVmKj0iLjE5NTZobC5jb20vIl0=")
    ],
    adGuardFrench: [
      "#pavePub",
      e("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"),
      ".mobile_adhesion",
      ".widgetadv",
      e("LmFkc19iYW4=")
    ],
    adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
    adGuardJapanese: [
      "#kauli_yad_1",
      e("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="),
      e("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="),
      e("LmFkZ29vZ2xl"),
      e("Ll9faXNib29zdFJldHVybkFk")
    ],
    adGuardMobile: [
      e("YW1wLWF1dG8tYWRz"),
      e("LmFtcF9hZA=="),
      'amp-embed[type="24smi"]',
      "#mgid_iframe1",
      e("I2FkX2ludmlld19hcmVh")
    ],
    adGuardRussian: [
      e("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="),
      e("LnJlY2xhbWE="),
      'div[id^="smi2adblock"]',
      e("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"),
      "#psyduckpockeball"
    ],
    adGuardSocial: [
      e("YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="),
      e("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="),
      ".etsy-tweet",
      "#inlineShare",
      ".popup-social"
    ],
    adGuardSpanishPortuguese: ["#barraPublicidade", "#Publicidade", "#publiEspecial", "#queTooltip", ".cnt-publi"],
    adGuardTrackingProtection: [
      "#qoo-counter",
      e("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="),
      e("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="),
      "#top100counter"
    ],
    adGuardTurkish: [
      "#backkapat",
      e("I3Jla2xhbWk="),
      e("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="),
      e("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"),
      e("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ==")
    ],
    bulgarian: [e("dGQjZnJlZW5ldF90YWJsZV9hZHM="), "#ea_intext_div", ".lapni-pop-over", "#xenium_hot_offers"],
    easyList: [
      ".yb-floorad",
      e("LndpZGdldF9wb19hZHNfd2lkZ2V0"),
      e("LnRyYWZmaWNqdW5reS1hZA=="),
      ".textad_headline",
      e("LnNwb25zb3JlZC10ZXh0LWxpbmtz")
    ],
    easyListChina: [
      e("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="),
      e("LmZyb250cGFnZUFkdk0="),
      "#taotaole",
      "#aafoot.top_box",
      ".cfa_popup"
    ],
    easyListCookie: [
      ".ezmob-footer",
      ".cc-CookieWarning",
      "[data-cookie-number]",
      e("LmF3LWNvb2tpZS1iYW5uZXI="),
      ".sygnal24-gdpr-modal-wrap"
    ],
    easyListCzechSlovak: [
      "#onlajny-stickers",
      e("I3Jla2xhbW5pLWJveA=="),
      e("LnJla2xhbWEtbWVnYWJvYXJk"),
      ".sklik",
      e("W2lkXj0ic2tsaWtSZWtsYW1hIl0=")
    ],
    easyListDutch: [
      e("I2FkdmVydGVudGll"),
      e("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="),
      ".adstekst",
      e("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="),
      "#semilo-lrectangle"
    ],
    easyListGermany: [
      "#SSpotIMPopSlider",
      e("LnNwb25zb3JsaW5rZ3J1ZW4="),
      e("I3dlcmJ1bmdza3k="),
      e("I3Jla2xhbWUtcmVjaHRzLW1pdHRl"),
      e("YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0=")
    ],
    easyListItaly: [
      e("LmJveF9hZHZfYW5udW5jaQ=="),
      ".sb-box-pubbliredazionale",
      e("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ==")
    ],
    easyListLithuania: [
      e("LnJla2xhbW9zX3RhcnBhcw=="),
      e("LnJla2xhbW9zX251b3JvZG9z"),
      e("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"),
      e("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"),
      e("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd")
    ],
    estonian: [e("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")],
    fanboyAnnoyances: ["#ac-lre-player", ".navigate-to-top", "#subscribe_popup", ".newsletter_holder", "#back-top"],
    fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
    fanboyEnhancedTrackers: [
      ".open.pushModal",
      "#issuem-leaky-paywall-articles-zero-remaining-nag",
      "#sovrn_container",
      'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
      ".BlockNag__Card"
    ],
    fanboySocial: ["#FollowUs", "#meteored_share", "#social_follow", ".article-sharer", ".community__social-desc"],
    frellwitSwedish: [
      e("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="),
      e("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="),
      "article.category-samarbete",
      e("ZGl2LmhvbGlkQWRz"),
      "ul.adsmodern"
    ],
    greekAdBlock: [
      e("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"),
      e("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="),
      e("QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"),
      "DIV.agores300",
      "TABLE.advright"
    ],
    hungarian: [
      "#cemp_doboz",
      ".optimonk-iframe-container",
      e("LmFkX19tYWlu"),
      e("W2NsYXNzKj0iR29vZ2xlQWRzIl0="),
      "#hirdetesek_box"
    ],
    iDontCareAboutCookies: [
      '.alert-info[data-block-track*="CookieNotice"]',
      ".ModuleTemplateCookieIndicator",
      ".o--cookies--container",
      "#cookies-policy-sticky",
      "#stickyCookieBar"
    ],
    icelandicAbp: [e("QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==")],
    latvian: [
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="),
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ==")
    ],
    listKr: [
      e("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="),
      e("I2xpdmVyZUFkV3JhcHBlcg=="),
      e("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="),
      e("aW5zLmZhc3R2aWV3LWFk"),
      ".revenue_unit_item.dable"
    ],
    listeAr: [
      e("LmdlbWluaUxCMUFk"),
      ".right-and-left-sponsers",
      e("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="),
      e("YVtocmVmKj0iYm9vcmFxLm9yZyJd"),
      e("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd")
    ],
    listeFr: [
      e("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="),
      e("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="),
      e("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="),
      ".site-pub-interstitiel",
      'div[id^="crt-"][data-criteo-id]'
    ],
    officialPolish: [
      "#ceneo-placeholder-ceneo-12",
      e("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"),
      e("YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="),
      e("ZGl2I3NrYXBpZWNfYWQ=")
    ],
    ro: [
      e("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="),
      e("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd"),
      'a[href^="/url/"]'
    ],
    ruAd: [
      e("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"),
      e("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="),
      e("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="),
      "#pgeldiz",
      ".yandex-rtb-block"
    ],
    thaiAds: [
      "a[href*=macau-uta-popup]",
      e("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="),
      e("LmFkczMwMHM="),
      ".bumq",
      ".img-kosana"
    ],
    webAnnoyancesUltralist: [
      "#mod-social-share-2",
      "#social-tools",
      e("LmN0cGwtZnVsbGJhbm5lcg=="),
      ".zergnet-recommend",
      ".yt.btn-link.btn-md.btn"
    ]
  };
}
function Fr(e) {
  var t = e === void 0 ? {} : e, r = t.debug;
  return G(this, void 0, void 0, function() {
    var n, o, a, s, c, f;
    return B(this, function(i) {
      switch (i.label) {
        case 0:
          return Rr() ? (n = Vr(), o = Object.keys(n), a = (f = []).concat.apply(f, o.map(function(l) {
            return n[l];
          })), [4, Wr(a)]) : [2, void 0];
        case 1:
          return s = i.sent(), r && Pr(n, s), c = o.filter(function(l) {
            var u = n[l], y = _(u.map(function(x) {
              return s[x];
            }));
            return y > u.length * 0.6;
          }), c.sort(), [2, c];
      }
    });
  });
}
function Rr() {
  return ie() || rt();
}
function Wr(e) {
  var t;
  return G(this, void 0, void 0, function() {
    var r, n, o, a, f, s, c, f;
    return B(this, function(i) {
      switch (i.label) {
        case 0:
          for (r = document, n = r.createElement("div"), o = new Array(e.length), a = {}, He(n), f = 0; f < e.length; ++f)
            s = Nt(e[f]), s.tagName === "DIALOG" && s.show(), c = r.createElement("div"), He(c), c.appendChild(s), n.appendChild(c), o[f] = s;
          i.label = 1;
        case 1:
          return r.body ? [3, 3] : [4, ee(50)];
        case 2:
          return i.sent(), [3, 1];
        case 3:
          return r.body.appendChild(n), [4, we()];
        case 4:
          i.sent();
          try {
            for (f = 0; f < e.length; ++f)
              o[f].offsetParent || (a[e[f]] = !0);
          } finally {
            (t = n.parentNode) === null || t === void 0 || t.removeChild(n);
          }
          return [2, a];
      }
    });
  });
}
function He(e) {
  e.style.setProperty("visibility", "hidden", "important"), e.style.setProperty("display", "block", "important");
}
function Pr(e, t) {
  for (var r = "DOM blockers debug:\n```", n = 0, o = Object.keys(e); n < o.length; n++) {
    var a = o[n];
    r += `
`.concat(a, ":");
    for (var s = 0, c = e[a]; s < c.length; s++) {
      var f = c[s];
      r += `
  `.concat(t[f] ? "🚫" : "➡️", " ").concat(f);
    }
  }
  console.log("".concat(r, "\n```"));
}
function Er() {
  for (var e = 0, t = ["rec2020", "p3", "srgb"]; e < t.length; e++) {
    var r = t[e];
    if (matchMedia("(color-gamut: ".concat(r, ")")).matches)
      return r;
  }
}
function Ir() {
  if (Oe("inverted"))
    return !0;
  if (Oe("none"))
    return !1;
}
function Oe(e) {
  return matchMedia("(inverted-colors: ".concat(e, ")")).matches;
}
function Mr() {
  if (De("active"))
    return !0;
  if (De("none"))
    return !1;
}
function De(e) {
  return matchMedia("(forced-colors: ".concat(e, ")")).matches;
}
var Ar = 100;
function Tr() {
  if (matchMedia("(min-monochrome: 0)").matches) {
    for (var e = 0; e <= Ar; ++e)
      if (matchMedia("(max-monochrome: ".concat(e, ")")).matches)
        return e;
    throw new Error("Too high value");
  }
}
function Zr() {
  if (K("no-preference"))
    return 0;
  if (K("high") || K("more"))
    return 1;
  if (K("low") || K("less"))
    return -1;
  if (K("forced"))
    return 10;
}
function K(e) {
  return matchMedia("(prefers-contrast: ".concat(e, ")")).matches;
}
function jr() {
  if (Ye("reduce"))
    return !0;
  if (Ye("no-preference"))
    return !1;
}
function Ye(e) {
  return matchMedia("(prefers-reduced-motion: ".concat(e, ")")).matches;
}
function Gr() {
  if (Ne("high"))
    return !0;
  if (Ne("standard"))
    return !1;
}
function Ne(e) {
  return matchMedia("(dynamic-range: ".concat(e, ")")).matches;
}
var W = Math, I = function() {
  return 0;
};
function Br() {
  var e = W.acos || I, t = W.acosh || I, r = W.asin || I, n = W.asinh || I, o = W.atanh || I, a = W.atan || I, s = W.sin || I, c = W.sinh || I, f = W.cos || I, i = W.cosh || I, l = W.tan || I, u = W.tanh || I, y = W.exp || I, x = W.expm1 || I, F = W.log1p || I, w = function(V) {
    return W.pow(W.PI, V);
  }, S = function(V) {
    return W.log(V + W.sqrt(V * V - 1));
  }, C = function(V) {
    return W.log(V + W.sqrt(V * V + 1));
  }, d = function(V) {
    return W.log((1 + V) / (1 - V)) / 2;
  }, v = function(V) {
    return W.exp(V) - 1 / W.exp(V) / 2;
  }, b = function(V) {
    return (W.exp(V) + 1 / W.exp(V)) / 2;
  }, k = function(V) {
    return W.exp(V) - 1;
  }, L = function(V) {
    return (W.exp(2 * V) - 1) / (W.exp(2 * V) + 1);
  }, R = function(V) {
    return W.log(1 + V);
  };
  return {
    acos: e(0.12312423423423424),
    acosh: t(1e308),
    acoshPf: S(1e154),
    asin: r(0.12312423423423424),
    asinh: n(1),
    asinhPf: C(1),
    atanh: o(0.5),
    atanhPf: d(0.5),
    atan: a(0.5),
    sin: s(-1e300),
    sinh: c(1),
    sinhPf: v(1),
    cos: f(10.000000000123),
    cosh: i(1),
    coshPf: b(1),
    tan: l(-1e300),
    tanh: u(1),
    tanhPf: L(1),
    exp: y(1),
    expm1: x(1),
    expm1Pf: k(1),
    log1p: F(10),
    log1pPf: R(10),
    powPI: w(-100)
  };
}
var _r = "mmMwWLliI0fiflO&1", ke = {
  /**
   * The default font. User can change it in desktop Chrome, desktop Firefox, IE 11,
   * Android Chrome (but only when the size is ≥ than the default) and Android Firefox.
   */
  default: [],
  /** OS font on macOS. User can change its size and weight. Applies after Safari restart. */
  apple: [{ font: "-apple-system-body" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  serif: [{ fontFamily: "serif" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  sans: [{ fontFamily: "sans-serif" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  mono: [{ fontFamily: "monospace" }],
  /**
   * Check the smallest allowed font size. User can change it in desktop Chrome, desktop Firefox and desktop Safari.
   * The height can be 0 in Chrome on a retina display.
   */
  min: [{ fontSize: "1px" }],
  /** Tells one OS from another in desktop Chrome. */
  system: [{ fontFamily: "system-ui" }]
};
function Hr() {
  return Or(function(e, t) {
    for (var r = {}, n = {}, o = 0, a = Object.keys(ke); o < a.length; o++) {
      var s = a[o], c = ke[s], f = c[0], i = f === void 0 ? {} : f, l = c[1], u = l === void 0 ? _r : l, y = e.createElement("span");
      y.textContent = u, y.style.whiteSpace = "nowrap";
      for (var x = 0, F = Object.keys(i); x < F.length; x++) {
        var w = F[x], S = i[w];
        S !== void 0 && (y.style[w] = S);
      }
      r[s] = y, t.appendChild(e.createElement("br")), t.appendChild(y);
    }
    for (var C = 0, d = Object.keys(ke); C < d.length; C++) {
      var s = d[C];
      n[s] = r[s].getBoundingClientRect().width;
    }
    return n;
  });
}
function Or(e, t) {
  return t === void 0 && (t = 4e3), nt(function(r, n) {
    var o = n.document, a = o.body, s = a.style;
    s.width = "".concat(t, "px"), s.webkitTextSizeAdjust = s.textSizeAdjust = "none", Ee() ? a.style.zoom = "".concat(1 / n.devicePixelRatio) : ie() && (a.style.zoom = "reset");
    var c = o.createElement("div");
    return c.textContent = Qe([], Array(t / 20 << 0), !0).map(function() {
      return "word";
    }).join(" "), a.appendChild(c), e(o, a);
  }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}
function Dr() {
  return navigator.pdfViewerEnabled;
}
function Yr() {
  var e = new Float32Array(1), t = new Uint8Array(e.buffer);
  return e[0] = 1 / 0, e[0] = e[0] - e[0], t[3];
}
function Nr() {
  var e = window.ApplePaySession;
  if (typeof (e == null ? void 0 : e.canMakePayments) != "function")
    return -1;
  try {
    return e.canMakePayments() ? 1 : 0;
  } catch (t) {
    return Xr(t);
  }
}
function Xr(e) {
  if (e instanceof Error) {
    if (e.name === "InvalidAccessError") {
      if (/\bfrom\b.*\binsecure\b/i.test(e.message))
        return -2;
      if (/\bdifferent\b.*\borigin\b.*top.level\b.*\bframe\b/i.test(e.message))
        return -3;
    }
    if (e.name === "SecurityError" && /\bthird.party iframes?.*\bnot.allowed\b/i.test(e.message))
      return -3;
  }
  throw e;
}
function zr() {
  var e, t = document.createElement("a"), r = (e = t.attributionSourceId) !== null && e !== void 0 ? e : t.attributionsourceid;
  return r === void 0 ? void 0 : String(r);
}
var at = -1, it = -2, Jr = /* @__PURE__ */ new Set([
  10752,
  2849,
  2884,
  2885,
  2886,
  2928,
  2929,
  2930,
  2931,
  2932,
  2960,
  2961,
  2962,
  2963,
  2964,
  2965,
  2966,
  2967,
  2968,
  2978,
  3024,
  3042,
  3088,
  3089,
  3106,
  3107,
  32773,
  32777,
  32777,
  32823,
  32824,
  32936,
  32937,
  32938,
  32939,
  32968,
  32969,
  32970,
  32971,
  3317,
  33170,
  3333,
  3379,
  3386,
  33901,
  33902,
  34016,
  34024,
  34076,
  3408,
  3410,
  3411,
  3412,
  3413,
  3414,
  3415,
  34467,
  34816,
  34817,
  34818,
  34819,
  34877,
  34921,
  34930,
  35660,
  35661,
  35724,
  35738,
  35739,
  36003,
  36004,
  36005,
  36347,
  36348,
  36349,
  37440,
  37441,
  37443,
  7936,
  7937,
  7938
  // SAMPLE_ALPHA_TO_COVERAGE (32926) and SAMPLE_COVERAGE (32928) are excluded because they trigger a console warning
  // in IE, Chrome ≤ 59 and Safari ≤ 13 and give no entropy.
]), Ur = /* @__PURE__ */ new Set([
  34047,
  35723,
  36063,
  34852,
  34853,
  34854,
  34229,
  36392,
  36795,
  38449
  // MAX_VIEWS_OVR
]), Qr = ["FRAGMENT_SHADER", "VERTEX_SHADER"], qr = ["LOW_FLOAT", "MEDIUM_FLOAT", "HIGH_FLOAT", "LOW_INT", "MEDIUM_INT", "HIGH_INT"], ot = "WEBGL_debug_renderer_info";
function Kr(e) {
  var t, r, n, o, a, s, c = e.cache, f = st(c);
  if (!f)
    return at;
  if (!ut(f))
    return it;
  var i = ct() ? null : f.getExtension(ot);
  return {
    version: ((t = f.getParameter(f.VERSION)) === null || t === void 0 ? void 0 : t.toString()) || "",
    vendor: ((r = f.getParameter(f.VENDOR)) === null || r === void 0 ? void 0 : r.toString()) || "",
    vendorUnmasked: i ? (n = f.getParameter(i.UNMASKED_VENDOR_WEBGL)) === null || n === void 0 ? void 0 : n.toString() : "",
    renderer: ((o = f.getParameter(f.RENDERER)) === null || o === void 0 ? void 0 : o.toString()) || "",
    rendererUnmasked: i ? (a = f.getParameter(i.UNMASKED_RENDERER_WEBGL)) === null || a === void 0 ? void 0 : a.toString() : "",
    shadingLanguageVersion: ((s = f.getParameter(f.SHADING_LANGUAGE_VERSION)) === null || s === void 0 ? void 0 : s.toString()) || ""
  };
}
function $r(e) {
  var t = e.cache, r = st(t);
  if (!r)
    return at;
  if (!ut(r))
    return it;
  var n = r.getSupportedExtensions(), o = r.getContextAttributes(), a = [], s = [], c = [], f = [];
  if (o)
    for (var i = 0, l = Object.keys(o); i < l.length; i++) {
      var u = l[i];
      a.push("".concat(u, "=").concat(o[u]));
    }
  for (var y = Xe(r), x = 0, F = y; x < F.length; x++) {
    var w = F[x], S = r[w];
    s.push("".concat(w, "=").concat(S).concat(Jr.has(S) ? "=".concat(r.getParameter(S)) : ""));
  }
  if (n)
    for (var C = 0, d = n; C < d.length; C++) {
      var v = d[C];
      if (!(v === ot && ct())) {
        var b = r.getExtension(v);
        if (b)
          for (var k = 0, L = Xe(b); k < L.length; k++) {
            var w = L[k], S = b[w];
            c.push("".concat(w, "=").concat(S).concat(Ur.has(S) ? "=".concat(r.getParameter(S)) : ""));
          }
      }
    }
  for (var R = 0, V = Qr; R < V.length; R++)
    for (var E = V[R], M = 0, H = qr; M < H.length; M++) {
      var Z = H[M], U = en(r, E, Z);
      f.push("".concat(E, ".").concat(Z, "=").concat(U.join(",")));
    }
  return c.sort(), s.sort(), {
    contextAttributes: a,
    parameters: s,
    shaderPrecisions: f,
    extensions: n,
    extensionParameters: c
  };
}
function st(e) {
  if (e.webgl)
    return e.webgl.context;
  var t = document.createElement("canvas"), r;
  t.addEventListener("webglCreateContextError", function() {
    return r = void 0;
  });
  for (var n = 0, o = ["webgl", "experimental-webgl"]; n < o.length; n++) {
    var a = o[n];
    try {
      r = t.getContext(a);
    } catch {
    }
    if (r)
      break;
  }
  return e.webgl = { context: r }, r;
}
function en(e, t, r) {
  var n = e.getShaderPrecisionFormat(e[t], e[r]);
  return n ? [n.rangeMin, n.rangeMax, n.precision] : [];
}
function Xe(e) {
  var t = Object.keys(e.__proto__);
  return t.filter(tn);
}
function tn(e) {
  return typeof e == "string" && !e.match(/[^A-Z0-9_x]/);
}
function ct() {
  return tt();
}
function ut(e) {
  return typeof e.getParameter == "function";
}
var rn = {
  // READ FIRST:
  // See https://github.com/fingerprintjs/fingerprintjs/blob/master/contributing.md#how-to-make-an-entropy-source
  // to learn how entropy source works and how to make your own.
  // The sources run in this exact order.
  // The asynchronous sources are at the start to run in parallel with other sources.
  fonts: Ut,
  domBlockers: Fr,
  fontPreferences: Hr,
  audio: Ht,
  screenFrame: vr,
  canvas: qt,
  osCpu: ar,
  languages: ir,
  colorDepth: or,
  deviceMemory: sr,
  screenResolution: cr,
  hardwareConcurrency: mr,
  timezone: hr,
  sessionStorage: gr,
  localStorage: yr,
  indexedDB: br,
  openDatabase: wr,
  cpuClass: Sr,
  platform: xr,
  plugins: Qt,
  touchSupport: nr,
  vendor: kr,
  vendorFlavors: Lr,
  cookiesEnabled: Cr,
  colorGamut: Er,
  invertedColors: Ir,
  forcedColors: Mr,
  monochrome: Tr,
  contrast: Zr,
  reducedMotion: jr,
  hdr: Gr,
  math: Br,
  pdfViewerEnabled: Dr,
  architecture: Yr,
  applePay: Nr,
  privateClickMeasurement: zr,
  // Some sources can affect other sources (e.g. WebGL can affect canvas), so it's important to run these sources
  // after other sources.
  webGlBasics: Kr,
  webGlExtensions: $r
};
function nn(e) {
  return At(rn, e, []);
}
var an = "$ if upgrade to Pro: https://fpjs.dev/pro";
function on(e) {
  var t = sn(e), r = cn(t);
  return { score: t, comment: an.replace(/\$/g, "".concat(r)) };
}
function sn(e) {
  if (rt())
    return 0.4;
  if (ie())
    return Ie() ? 0.5 : 0.3;
  var t = "value" in e.platform ? e.platform.value : "";
  return /^Win/.test(t) ? 0.6 : /^Mac/.test(t) ? 0.5 : 0.7;
}
function cn(e) {
  return $e(0.99 + 0.01 * e, 1e-4);
}
function un(e) {
  for (var t = "", r = 0, n = Object.keys(e).sort(); r < n.length; r++) {
    var o = n[r], a = e[o], s = "error" in a ? "error" : JSON.stringify(a.value);
    t += "".concat(t ? "|" : "").concat(o.replace(/([:|\\])/g, "\\$1"), ":").concat(s);
  }
  return t;
}
function ft(e) {
  return JSON.stringify(e, function(t, r) {
    return r instanceof Error ? Et(r) : r;
  }, 2);
}
function lt(e) {
  return Pt(un(e));
}
function fn(e) {
  var t, r = on(e);
  return {
    get visitorId() {
      return t === void 0 && (t = lt(this.components)), t;
    },
    set visitorId(n) {
      t = n;
    },
    confidence: r,
    components: e,
    version: qe
  };
}
function ln(e) {
  return e === void 0 && (e = 50), St(e, e * 2);
}
function dn(e, t) {
  var r = Date.now();
  return {
    get: function(n) {
      return G(this, void 0, void 0, function() {
        var o, a, s;
        return B(this, function(c) {
          switch (c.label) {
            case 0:
              return o = Date.now(), [4, e()];
            case 1:
              return a = c.sent(), s = fn(a), (t || n != null && n.debug) && console.log("Copy the text below to get the debug data:\n\n```\nversion: ".concat(s.version, `
userAgent: `).concat(navigator.userAgent, `
timeBetweenLoadAndGet: `).concat(o - r, `
visitorId: `).concat(s.visitorId, `
components: `).concat(ft(a), "\n```")), [2, s];
          }
        });
      });
    }
  };
}
function vn() {
  if (!(window.__fpjs_d_m || Math.random() >= 1e-3))
    try {
      var e = new XMLHttpRequest();
      e.open("get", "https://m1.openfpcdn.io/fingerprintjs/v".concat(qe, "/npm-monitoring"), !0), e.send();
    } catch (t) {
      console.error(t);
    }
}
function mn(e) {
  var t = e === void 0 ? {} : e, r = t.delayFallback, n = t.debug, o = t.monitoring, a = o === void 0 ? !0 : o;
  return G(this, void 0, void 0, function() {
    var s;
    return B(this, function(c) {
      switch (c.label) {
        case 0:
          return a && vn(), [4, ln(r)];
        case 1:
          return c.sent(), s = nn({ cache: {}, debug: n }), [2, dn(s, n)];
      }
    });
  });
}
var hn = { load: mn, hashComponents: lt, componentsToDebugString: ft }, Y = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function pn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function gn(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var dt = { exports: {} };
function yn(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Le = { exports: {} };
const bn = {}, wn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bn
}, Symbol.toStringTag, { value: "Module" })), Sn = /* @__PURE__ */ gn(wn);
var ze;
function xn() {
  return ze || (ze = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Y, function() {
      var r = r || function(n, o) {
        var a;
        if (typeof window < "u" && window.crypto && (a = window.crypto), typeof self < "u" && self.crypto && (a = self.crypto), typeof globalThis < "u" && globalThis.crypto && (a = globalThis.crypto), !a && typeof window < "u" && window.msCrypto && (a = window.msCrypto), !a && typeof Y < "u" && Y.crypto && (a = Y.crypto), !a && typeof yn == "function")
          try {
            a = Sn;
          } catch {
          }
        var s = function() {
          if (a) {
            if (typeof a.getRandomValues == "function")
              try {
                return a.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof a.randomBytes == "function")
              try {
                return a.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, c = Object.create || function() {
          function d() {
          }
          return function(v) {
            var b;
            return d.prototype = v, b = new d(), d.prototype = null, b;
          };
        }(), f = {}, i = f.lib = {}, l = i.Base = function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(d) {
              var v = c(this);
              return d && v.mixIn(d), (!v.hasOwnProperty("init") || this.init === v.init) && (v.init = function() {
                v.$super.init.apply(this, arguments);
              }), v.init.prototype = v, v.$super = this, v;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var d = this.extend();
              return d.init.apply(d, arguments), d;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(d) {
              for (var v in d)
                d.hasOwnProperty(v) && (this[v] = d[v]);
              d.hasOwnProperty("toString") && (this.toString = d.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), u = i.WordArray = l.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(d, v) {
            d = this.words = d || [], v != o ? this.sigBytes = v : this.sigBytes = d.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(d) {
            return (d || x).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(d) {
            var v = this.words, b = d.words, k = this.sigBytes, L = d.sigBytes;
            if (this.clamp(), k % 4)
              for (var R = 0; R < L; R++) {
                var V = b[R >>> 2] >>> 24 - R % 4 * 8 & 255;
                v[k + R >>> 2] |= V << 24 - (k + R) % 4 * 8;
              }
            else
              for (var E = 0; E < L; E += 4)
                v[k + E >>> 2] = b[E >>> 2];
            return this.sigBytes += L, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var d = this.words, v = this.sigBytes;
            d[v >>> 2] &= 4294967295 << 32 - v % 4 * 8, d.length = n.ceil(v / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var d = l.clone.call(this);
            return d.words = this.words.slice(0), d;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(d) {
            for (var v = [], b = 0; b < d; b += 4)
              v.push(s());
            return new u.init(v, d);
          }
        }), y = f.enc = {}, x = y.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(d) {
            for (var v = d.words, b = d.sigBytes, k = [], L = 0; L < b; L++) {
              var R = v[L >>> 2] >>> 24 - L % 4 * 8 & 255;
              k.push((R >>> 4).toString(16)), k.push((R & 15).toString(16));
            }
            return k.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(d) {
            for (var v = d.length, b = [], k = 0; k < v; k += 2)
              b[k >>> 3] |= parseInt(d.substr(k, 2), 16) << 24 - k % 8 * 4;
            return new u.init(b, v / 2);
          }
        }, F = y.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(d) {
            for (var v = d.words, b = d.sigBytes, k = [], L = 0; L < b; L++) {
              var R = v[L >>> 2] >>> 24 - L % 4 * 8 & 255;
              k.push(String.fromCharCode(R));
            }
            return k.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(d) {
            for (var v = d.length, b = [], k = 0; k < v; k++)
              b[k >>> 2] |= (d.charCodeAt(k) & 255) << 24 - k % 4 * 8;
            return new u.init(b, v);
          }
        }, w = y.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(d) {
            try {
              return decodeURIComponent(escape(F.stringify(d)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(d) {
            return F.parse(unescape(encodeURIComponent(d)));
          }
        }, S = i.BufferedBlockAlgorithm = l.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new u.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(d) {
            typeof d == "string" && (d = w.parse(d)), this._data.concat(d), this._nDataBytes += d.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(d) {
            var v, b = this._data, k = b.words, L = b.sigBytes, R = this.blockSize, V = R * 4, E = L / V;
            d ? E = n.ceil(E) : E = n.max((E | 0) - this._minBufferSize, 0);
            var M = E * R, H = n.min(M * 4, L);
            if (M) {
              for (var Z = 0; Z < M; Z += R)
                this._doProcessBlock(k, Z);
              v = k.splice(0, M), b.sigBytes -= H;
            }
            return new u.init(v, H);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var d = l.clone.call(this);
            return d._data = this._data.clone(), d;
          },
          _minBufferSize: 0
        });
        i.Hasher = S.extend({
          /**
           * Configuration options.
           */
          cfg: l.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(d) {
            this.cfg = this.cfg.extend(d), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            S.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(d) {
            return this._append(d), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(d) {
            d && this._append(d);
            var v = this._doFinalize();
            return v;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(d) {
            return function(v, b) {
              return new d.init(b).finalize(v);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(d) {
            return function(v, b) {
              return new C.HMAC.init(d, b).finalize(v);
            };
          }
        });
        var C = f.algo = {};
        return f;
      }(Math);
      return r;
    });
  }(Le)), Le.exports;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n(xn());
  })(Y, function(r) {
    return function(n) {
      var o = r, a = o.lib, s = a.WordArray, c = a.Hasher, f = o.algo, i = [];
      (function() {
        for (var w = 0; w < 64; w++)
          i[w] = n.abs(n.sin(w + 1)) * 4294967296 | 0;
      })();
      var l = f.MD5 = c.extend({
        _doReset: function() {
          this._hash = new s.init([
            1732584193,
            4023233417,
            2562383102,
            271733878
          ]);
        },
        _doProcessBlock: function(w, S) {
          for (var C = 0; C < 16; C++) {
            var d = S + C, v = w[d];
            w[d] = (v << 8 | v >>> 24) & 16711935 | (v << 24 | v >>> 8) & 4278255360;
          }
          var b = this._hash.words, k = w[S + 0], L = w[S + 1], R = w[S + 2], V = w[S + 3], E = w[S + 4], M = w[S + 5], H = w[S + 6], Z = w[S + 7], U = w[S + 8], se = w[S + 9], ce = w[S + 10], ue = w[S + 11], fe = w[S + 12], le = w[S + 13], de = w[S + 14], ve = w[S + 15], m = b[0], h = b[1], p = b[2], g = b[3];
          m = u(m, h, p, g, k, 7, i[0]), g = u(g, m, h, p, L, 12, i[1]), p = u(p, g, m, h, R, 17, i[2]), h = u(h, p, g, m, V, 22, i[3]), m = u(m, h, p, g, E, 7, i[4]), g = u(g, m, h, p, M, 12, i[5]), p = u(p, g, m, h, H, 17, i[6]), h = u(h, p, g, m, Z, 22, i[7]), m = u(m, h, p, g, U, 7, i[8]), g = u(g, m, h, p, se, 12, i[9]), p = u(p, g, m, h, ce, 17, i[10]), h = u(h, p, g, m, ue, 22, i[11]), m = u(m, h, p, g, fe, 7, i[12]), g = u(g, m, h, p, le, 12, i[13]), p = u(p, g, m, h, de, 17, i[14]), h = u(h, p, g, m, ve, 22, i[15]), m = y(m, h, p, g, L, 5, i[16]), g = y(g, m, h, p, H, 9, i[17]), p = y(p, g, m, h, ue, 14, i[18]), h = y(h, p, g, m, k, 20, i[19]), m = y(m, h, p, g, M, 5, i[20]), g = y(g, m, h, p, ce, 9, i[21]), p = y(p, g, m, h, ve, 14, i[22]), h = y(h, p, g, m, E, 20, i[23]), m = y(m, h, p, g, se, 5, i[24]), g = y(g, m, h, p, de, 9, i[25]), p = y(p, g, m, h, V, 14, i[26]), h = y(h, p, g, m, U, 20, i[27]), m = y(m, h, p, g, le, 5, i[28]), g = y(g, m, h, p, R, 9, i[29]), p = y(p, g, m, h, Z, 14, i[30]), h = y(h, p, g, m, fe, 20, i[31]), m = x(m, h, p, g, M, 4, i[32]), g = x(g, m, h, p, U, 11, i[33]), p = x(p, g, m, h, ue, 16, i[34]), h = x(h, p, g, m, de, 23, i[35]), m = x(m, h, p, g, L, 4, i[36]), g = x(g, m, h, p, E, 11, i[37]), p = x(p, g, m, h, Z, 16, i[38]), h = x(h, p, g, m, ce, 23, i[39]), m = x(m, h, p, g, le, 4, i[40]), g = x(g, m, h, p, k, 11, i[41]), p = x(p, g, m, h, V, 16, i[42]), h = x(h, p, g, m, H, 23, i[43]), m = x(m, h, p, g, se, 4, i[44]), g = x(g, m, h, p, fe, 11, i[45]), p = x(p, g, m, h, ve, 16, i[46]), h = x(h, p, g, m, R, 23, i[47]), m = F(m, h, p, g, k, 6, i[48]), g = F(g, m, h, p, Z, 10, i[49]), p = F(p, g, m, h, de, 15, i[50]), h = F(h, p, g, m, M, 21, i[51]), m = F(m, h, p, g, fe, 6, i[52]), g = F(g, m, h, p, V, 10, i[53]), p = F(p, g, m, h, ce, 15, i[54]), h = F(h, p, g, m, L, 21, i[55]), m = F(m, h, p, g, U, 6, i[56]), g = F(g, m, h, p, ve, 10, i[57]), p = F(p, g, m, h, H, 15, i[58]), h = F(h, p, g, m, le, 21, i[59]), m = F(m, h, p, g, E, 6, i[60]), g = F(g, m, h, p, ue, 10, i[61]), p = F(p, g, m, h, R, 15, i[62]), h = F(h, p, g, m, se, 21, i[63]), b[0] = b[0] + m | 0, b[1] = b[1] + h | 0, b[2] = b[2] + p | 0, b[3] = b[3] + g | 0;
        },
        _doFinalize: function() {
          var w = this._data, S = w.words, C = this._nDataBytes * 8, d = w.sigBytes * 8;
          S[d >>> 5] |= 128 << 24 - d % 32;
          var v = n.floor(C / 4294967296), b = C;
          S[(d + 64 >>> 9 << 4) + 15] = (v << 8 | v >>> 24) & 16711935 | (v << 24 | v >>> 8) & 4278255360, S[(d + 64 >>> 9 << 4) + 14] = (b << 8 | b >>> 24) & 16711935 | (b << 24 | b >>> 8) & 4278255360, w.sigBytes = (S.length + 1) * 4, this._process();
          for (var k = this._hash, L = k.words, R = 0; R < 4; R++) {
            var V = L[R];
            L[R] = (V << 8 | V >>> 24) & 16711935 | (V << 24 | V >>> 8) & 4278255360;
          }
          return k;
        },
        clone: function() {
          var w = c.clone.call(this);
          return w._hash = this._hash.clone(), w;
        }
      });
      function u(w, S, C, d, v, b, k) {
        var L = w + (S & C | ~S & d) + v + k;
        return (L << b | L >>> 32 - b) + S;
      }
      function y(w, S, C, d, v, b, k) {
        var L = w + (S & d | C & ~d) + v + k;
        return (L << b | L >>> 32 - b) + S;
      }
      function x(w, S, C, d, v, b, k) {
        var L = w + (S ^ C ^ d) + v + k;
        return (L << b | L >>> 32 - b) + S;
      }
      function F(w, S, C, d, v, b, k) {
        var L = w + (C ^ (S | ~d)) + v + k;
        return (L << b | L >>> 32 - b) + S;
      }
      o.MD5 = c._createHelper(l), o.HmacMD5 = c._createHmacHelper(l);
    }(Math), r.MD5;
  });
})(dt);
var kn = dt.exports;
const Ln = /* @__PURE__ */ pn(kn);
var J = {}, Me = {};
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
Me.parse = Fn;
Me.serialize = Rn;
var Cn = decodeURIComponent, Vn = encodeURIComponent, ge = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
function Fn(e, t) {
  if (typeof e != "string")
    throw new TypeError("argument str must be a string");
  for (var r = {}, n = t || {}, o = e.split(";"), a = n.decode || Cn, s = 0; s < o.length; s++) {
    var c = o[s], f = c.indexOf("=");
    if (!(f < 0)) {
      var i = c.substring(0, f).trim();
      if (r[i] == null) {
        var l = c.substring(f + 1, c.length).trim();
        l[0] === '"' && (l = l.slice(1, -1)), r[i] = Wn(l, a);
      }
    }
  }
  return r;
}
function Rn(e, t, r) {
  var n = r || {}, o = n.encode || Vn;
  if (typeof o != "function")
    throw new TypeError("option encode is invalid");
  if (!ge.test(e))
    throw new TypeError("argument name is invalid");
  var a = o(t);
  if (a && !ge.test(a))
    throw new TypeError("argument val is invalid");
  var s = e + "=" + a;
  if (n.maxAge != null) {
    var c = n.maxAge - 0;
    if (isNaN(c) || !isFinite(c))
      throw new TypeError("option maxAge is invalid");
    s += "; Max-Age=" + Math.floor(c);
  }
  if (n.domain) {
    if (!ge.test(n.domain))
      throw new TypeError("option domain is invalid");
    s += "; Domain=" + n.domain;
  }
  if (n.path) {
    if (!ge.test(n.path))
      throw new TypeError("option path is invalid");
    s += "; Path=" + n.path;
  }
  if (n.expires) {
    if (typeof n.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    s += "; Expires=" + n.expires.toUTCString();
  }
  if (n.httpOnly && (s += "; HttpOnly"), n.secure && (s += "; Secure"), n.sameSite) {
    var f = typeof n.sameSite == "string" ? n.sameSite.toLowerCase() : n.sameSite;
    switch (f) {
      case !0:
        s += "; SameSite=Strict";
        break;
      case "lax":
        s += "; SameSite=Lax";
        break;
      case "strict":
        s += "; SameSite=Strict";
        break;
      case "none":
        s += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return s;
}
function Wn(e, t) {
  try {
    return t(e);
  } catch {
    return e;
  }
}
var oe = { exports: {} }, $ = {
  decodeValues: !0,
  map: !1,
  silent: !1
};
function Re(e) {
  return typeof e == "string" && !!e.trim();
}
function We(e, t) {
  var r = e.split(";").filter(Re), n = r.shift(), o = Pn(n), a = o.name, s = o.value;
  t = t ? Object.assign({}, $, t) : $;
  try {
    s = t.decodeValues ? decodeURIComponent(s) : s;
  } catch (f) {
    console.error(
      "set-cookie-parser encountered an error while decoding a cookie with value '" + s + "'. Set options.decodeValues to false to disable this feature.",
      f
    );
  }
  var c = {
    name: a,
    value: s
  };
  return r.forEach(function(f) {
    var i = f.split("="), l = i.shift().trimLeft().toLowerCase(), u = i.join("=");
    l === "expires" ? c.expires = new Date(u) : l === "max-age" ? c.maxAge = parseInt(u, 10) : l === "secure" ? c.secure = !0 : l === "httponly" ? c.httpOnly = !0 : l === "samesite" ? c.sameSite = u : c[l] = u;
  }), c;
}
function Pn(e) {
  var t = "", r = "", n = e.split("=");
  return n.length > 1 ? (t = n.shift(), r = n.join("=")) : r = e, { name: t, value: r };
}
function vt(e, t) {
  if (t = t ? Object.assign({}, $, t) : $, !e)
    return t.map ? {} : [];
  if (e.headers)
    if (typeof e.headers.getSetCookie == "function")
      e = e.headers.getSetCookie();
    else if (e.headers["set-cookie"])
      e = e.headers["set-cookie"];
    else {
      var r = e.headers[Object.keys(e.headers).find(function(o) {
        return o.toLowerCase() === "set-cookie";
      })];
      !r && e.headers.cookie && !t.silent && console.warn(
        "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
      ), e = r;
    }
  if (Array.isArray(e) || (e = [e]), t = t ? Object.assign({}, $, t) : $, t.map) {
    var n = {};
    return e.filter(Re).reduce(function(o, a) {
      var s = We(a, t);
      return o[s.name] = s, o;
    }, n);
  } else
    return e.filter(Re).map(function(o) {
      return We(o, t);
    });
}
function En(e) {
  if (Array.isArray(e))
    return e;
  if (typeof e != "string")
    return [];
  var t = [], r = 0, n, o, a, s, c;
  function f() {
    for (; r < e.length && /\s/.test(e.charAt(r)); )
      r += 1;
    return r < e.length;
  }
  function i() {
    return o = e.charAt(r), o !== "=" && o !== ";" && o !== ",";
  }
  for (; r < e.length; ) {
    for (n = r, c = !1; f(); )
      if (o = e.charAt(r), o === ",") {
        for (a = r, r += 1, f(), s = r; r < e.length && i(); )
          r += 1;
        r < e.length && e.charAt(r) === "=" ? (c = !0, r = s, t.push(e.substring(n, a)), n = r) : r = a + 1;
      } else
        r += 1;
    (!c || r >= e.length) && t.push(e.substring(n, e.length));
  }
  return t;
}
oe.exports = vt;
oe.exports.parse = vt;
oe.exports.parseString = We;
oe.exports.splitCookiesString = En;
var In = oe.exports, O = {}, N = Y && Y.__assign || function() {
  return N = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, N.apply(this, arguments);
};
Object.defineProperty(O, "__esModule", { value: !0 });
O.areCookiesEqual = O.hasSameProperties = O.createCookie = O.isBrowser = void 0;
function Mn() {
  return typeof window < "u";
}
O.isBrowser = Mn;
function An(e, t, r) {
  var n = r.sameSite;
  n === !0 && (n = "strict"), (n === void 0 || n === !1) && (n = "lax");
  var o = N(N({}, r), { sameSite: n });
  return delete o.encode, N({ name: e, value: t }, o);
}
O.createCookie = An;
function mt(e, t) {
  var r = Object.getOwnPropertyNames(e), n = Object.getOwnPropertyNames(t);
  if (r.length !== n.length)
    return !1;
  for (var o = 0; o < r.length; o++) {
    var a = r[o];
    if (e[a] !== t[a])
      return !1;
  }
  return !0;
}
O.hasSameProperties = mt;
function Tn(e, t) {
  var r = e.sameSite === t.sameSite;
  return typeof e.sameSite == "string" && typeof t.sameSite == "string" && (r = e.sameSite.toLowerCase() === t.sameSite.toLowerCase()), mt(N(N({}, e), { sameSite: void 0 }), N(N({}, t), { sameSite: void 0 })) && r;
}
O.areCookiesEqual = Tn;
var ae = Y && Y.__assign || function() {
  return ae = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, ae.apply(this, arguments);
};
Object.defineProperty(J, "__esModule", { value: !0 });
J.destroyCookie = gt = J.setCookie = pt = J.parseCookies = void 0;
var re = Me, Zn = In, be = O;
function ht(e, t) {
  var r, n;
  return !((n = (r = e == null ? void 0 : e.req) === null || r === void 0 ? void 0 : r.headers) === null || n === void 0) && n.cookie ? re.parse(e.req.headers.cookie, t) : be.isBrowser() ? re.parse(document.cookie, t) : {};
}
var pt = J.parseCookies = ht;
function Ae(e, t, r, n) {
  var o, a;
  if (n === void 0 && (n = {}), !((o = e == null ? void 0 : e.res) === null || o === void 0) && o.getHeader && e.res.setHeader) {
    if (!((a = e == null ? void 0 : e.res) === null || a === void 0) && a.finished)
      return console.warn('Not setting "' + t + '" cookie. Response has finished.'), console.warn("You should set cookie before res.send()"), {};
    var s = e.res.getHeader("Set-Cookie") || [];
    typeof s == "string" && (s = [s]), typeof s == "number" && (s = []);
    var c = Zn.parse(s, {
      decodeValues: !1
    }), f = be.createCookie(t, r, n), i = [];
    c.forEach(function(l) {
      if (!be.areCookiesEqual(l, f)) {
        var u = re.serialize(l.name, l.value, ae({
          // we prevent reencoding by default, but you might override it
          encode: function(y) {
            return y;
          }
        }, l));
        i.push(u);
      }
    }), i.push(re.serialize(t, r, n)), e.res.setHeader("Set-Cookie", i);
  }
  if (be.isBrowser()) {
    if (n && n.httpOnly)
      throw new Error("Can not set a httpOnly cookie in the browser.");
    document.cookie = re.serialize(t, r, n);
  }
  return {};
}
var gt = J.setCookie = Ae;
function yt(e, t, r) {
  return Ae(e, t, "", ae(ae({}, r || {}), { maxAge: -1 }));
}
J.destroyCookie = yt;
J.default = {
  set: Ae,
  get: ht,
  destroy: yt
};
const te = "d2", jn = "st", Je = {
  debug: !1,
  domain: ""
}, z = class z {
  constructor(t) {
    // private fingerData: fingerDataType
    me(this, "config");
    me(this, "getUa", (t) => {
      var n, o, a, s, c;
      return (typeof window > "u" ? (a = (o = (n = t == null ? void 0 : t.req) == null ? void 0 : n.headers) == null ? void 0 : o["user-agent"]) == null ? void 0 : a.toLowerCase() : (c = (s = window == null ? void 0 : window.navigator) == null ? void 0 : s.userAgent) == null ? void 0 : c.toLowerCase()) || "";
    });
    if (this.config = t ? Object.assign({}, Je, t) : Je, z.instance && z.instance instanceof z)
      return z.instance;
    z.instance = this;
  }
  createFingerprint() {
    return hn.load().then((r) => r.get()).then((r) => r.visitorId).catch((r) => {
      console.error("create Fingerprint Error: ", r);
    });
  }
  isSayWeeeApp(t) {
    var o;
    const r = (t == null ? void 0 : t.ctx) || null, n = ((o = t == null ? void 0 : t.ua) == null ? void 0 : o.toLowerCase()) || this.getUa(r);
    return n ? n.indexOf("weeeapp") > -1 : !1;
  }
  async init() {
    if (this.isSayWeeeApp() || this.getData(te))
      return this.getData();
    const t = await this.createFingerprint();
    return t && this.setData({
      [te]: t
      // [SIGNATURE_TOKEN]: this.createEncrptFingerprint(visitorId)
    }), this.getData();
  }
  getData(t) {
    const r = pt();
    return t ? r[t] : {
      [te]: r[te] || "",
      [jn]: this.createEncrptFingerprint(r[te]) || ""
    };
  }
  setData(t) {
    let n = {
      maxAge: 86400,
      path: "/"
    };
    this.config.domain && (n = Object.assign({}, n, { domain: this.config.domain }));
    for (const o in t)
      gt(null, o, t[o], n);
  }
  reverseString(t) {
    return t.split("").reverse().join("") || "";
  }
  createEncrptFingerprint(t) {
    if (!window || !t)
      return "";
    const r = window.navigator.userAgent, n = Ln(`${this.reverseString(t)}+${r}`).toString();
    return this.config.debug && console.log("creact new st data: ", {
      d2: t,
      ua: r,
      st: n
    }), n;
  }
};
me(z, "instance");
let Ue = z;
export {
  te as DEVICE_ID_V2,
  Ue as Fingerprint,
  jn as SIGNATURE_TOKEN
};
